import { createIcon } from '@chakra-ui/icons'

const ArrowRight = createIcon({
  displayName: 'ArrowRight',
  viewBox: '0 0 21 29',
  defaultProps: {
    width: '21px',
    height: '29px',
    color: 'red.primary4',
    fill: 'none',
  },
  path: (
    <path
      d="M3 25.999L15 14.499L3 2.99902"
      stroke="currentColor"
      strokeWidth="8"
    />
  ),
})

export default ArrowRight
